import { AnnularRingWeldLineFeature3D } from './AnnularRingWeldLineFeature3D'
import { AnnularRingFeature3D } from './AnnularRingFeature3D'
import { CircumferentialWeldFeature3D } from './CircumferentialWeldFeature3D'
import { CoatingRegionFeature3D } from './CoatingRegion3D'
import { ConeCircumferentialWeldFeature3D } from './cone/ConeCircumferentialWeldFeature3D'
import { ConeRadialWeldFeature3D } from './cone/ConeRadialWeldFeature3D'
import { ConicalPlateFeature3D } from './cone/ConicalPlateFeature3D'
import { SphericalPlateFeature3D } from './dome/SphericalPlateFeature3D'
import { FixedSensorFeature3D } from './FixedSensorFeature3D'
import { GenericHeadCircumferentialWeldFeature3D } from './GenericHeadCircumferentialWeldFeature3D'
import { GenericHeadRadialWeldFeature3D } from './GenericHeadRadialWeldFeature3D'
import { HorizontalWeldFeature3D } from './HorizontalWeldFeature3D'
import { LeakDetectionValveFeature3D } from './LeakDetectionValveFeature3D'
import { LinerRegionFeature3D } from './LinerRegion3D'
import { ManwayFeature3D } from './ManwayFeature3D'
import { NozzleFeature3D } from './NozzleFeature3D'
import { PipeWrapFeature3D } from './pipeSection/PipeWrapFeature3D'
import { PlateFeature3D } from './PlateFeature3D'
import { PolygonalPlateFeature3D } from './PolygonalPlateFeature3D'
import { RectangularManwayFeature3D } from './RectangularManwayFeature3D'
import { SeamWeldFeature3D } from './SeamWeldFeature3D'
import { DeckBittFeature3D } from './shipDeck/DeckBittFeature3D'
import { DeckBulkheadFeature3D } from './shipDeck/DeckBulkheadFeature3D'
import { DeckChockFeature3D } from './shipDeck/DeckChockFeature3D'
import { DeckCoamingFeature3D } from './shipDeck/DeckCoamingFeature3D'
import { DeckCompartmentFeature3D } from './shipDeck/DeckCompartmentFeature3D'
import { DeckDoorFeature3D } from './shipDeck/DeckDoorFeature3D'
import { DeckDrainFeature3D } from './shipDeck/DeckDrainFeature3D'
import { DeckHatchFeature3D } from './shipDeck/DeckHatchFeature3D'
import { DeckLadderFeature3D } from './shipDeck/DeckLadderFeature3D'
import { DeckLockerFeature3D } from './shipDeck/DeckLockerFeature3D'
import { VerticalWeldFeature3D } from './VerticalWeldFeature3D'
import {
  GeckoAnnularRing,
  GeckoAnnularRingWeldLine,
  GeckoCircumferentialWeld,
  GeckoCoatingRegion,
  GeckoConeCircumferentialWeld,
  GeckoConeRadialWeld,
  GeckoConicalPlate,
  GeckoFeatureModelType,
  GeckoFixedSensor,
  GeckoGenericHeadCircumferentialWeld,
  GeckoGenericHeadRadialWeld,
  GeckoHorizontalWeld,
  GeckoLeakDetectionValve,
  GeckoLinerRegion,
  GeckoManway,
  GeckoNozzle,
  GeckoPipeWrap,
  GeckoPlate,
  GeckoPolygonalPlate,
  GeckoRectangularManway,
  GeckoSeamWeld,
  GeckoShipDeckBitt,
  GeckoShipDeckBulkhead,
  GeckoShipDeckChock,
  GeckoShipDeckCoaming,
  GeckoShipDeckCompartment,
  GeckoShipDeckDoor,
  GeckoShipDeckDrain,
  GeckoShipDeckHatch,
  GeckoShipDeckLadder,
  GeckoShipDeckLocker,
  GeckoSphericalPlate,
  GeckoVerticalWeld,
} from 'types'

type SupportedFeatureDispatchClass =
  | GeckoPlate
  | GeckoVerticalWeld
  | GeckoHorizontalWeld
  | GeckoConeCircumferentialWeld
  | GeckoConeRadialWeld
  | GeckoManway
  | GeckoRectangularManway
  | GeckoNozzle
  | GeckoLeakDetectionValve
  | GeckoFixedSensor
  | GeckoShipDeckCompartment
  | GeckoShipDeckBitt
  | GeckoShipDeckCoaming
  | GeckoShipDeckChock
  | GeckoShipDeckHatch
  | GeckoShipDeckLocker
  | GeckoShipDeckLadder
  | GeckoShipDeckBulkhead
  | GeckoShipDeckDoor
  | GeckoShipDeckDrain
  | GeckoSeamWeld
  | GeckoCircumferentialWeld
  | GeckoGenericHeadCircumferentialWeld
  | GeckoGenericHeadRadialWeld
  | GeckoPipeWrap
  | GeckoConicalPlate
  | GeckoPolygonalPlate
  | GeckoCoatingRegion
  | GeckoSphericalPlate
  | GeckoLinerRegion
  | GeckoAnnularRing
  | GeckoAnnularRingWeldLine

type Nested<T> = T[] | Nested<T>[]

interface FeatureDispatchProps {
  features: Nested<SupportedFeatureDispatchClass>
}

export const FeatureDispatch = ({ features }: FeatureDispatchProps) => {
  const flatFeatures = (features as SupportedFeatureDispatchClass[]).flat(
    Infinity
  ) as SupportedFeatureDispatchClass[]
  return (
    <>
      {flatFeatures.map((feature) =>
        feature.type === GeckoFeatureModelType.Manway ? (
          <ManwayFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.RectangularManway ? (
          <RectangularManwayFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.Nozzle ? (
          <NozzleFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.VerticalWeld ? (
          <VerticalWeldFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.HorizontalWeld ? (
          <HorizontalWeldFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.CoatingRegion ? (
          <CoatingRegionFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.LinerRegion ? (
          <LinerRegionFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.Plate ? (
          <PlateFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.FixedSensor ? (
          <FixedSensorFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.PolygonalPlate ? (
          <PolygonalPlateFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckCompartment ? (
          <DeckCompartmentFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckBitt ? (
          <DeckBittFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckCoaming ? (
          <DeckCoamingFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckChock ? (
          <DeckChockFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckHatch ? (
          <DeckHatchFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckLocker ? (
          <DeckLockerFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckLadder ? (
          <DeckLadderFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckBulkhead ? (
          <DeckBulkheadFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckDoor ? (
          <DeckDoorFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckDrain ? (
          <DeckDrainFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.SphericalPlate ? (
          <SphericalPlateFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.CircumferentialWeld ? (
          <CircumferentialWeldFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.SeamWeld ? (
          <SeamWeldFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.PipeWrap ? (
          <PipeWrapFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ConePlate ? (
          <ConicalPlateFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ConeRadialWeld ? (
          <ConeRadialWeldFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ConeCircumferentialWeld ? (
          <ConeCircumferentialWeldFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.LeakDetectionValve ? (
          <LeakDetectionValveFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.AnnularRing ? (
          <AnnularRingFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.AnnularRingWeldLine ? (
          <AnnularRingWeldLineFeature3D key={feature.id} model={feature} />
        ) : feature.type ===
          GeckoFeatureModelType.GenericHeadCircumferentialWeld ? (
          <GenericHeadCircumferentialWeldFeature3D
            key={feature.id}
            model={feature}
          />
        ) : feature.type === GeckoFeatureModelType.GenericHeadRadialWeld ? (
          <GenericHeadRadialWeldFeature3D key={feature.id} model={feature} />
        ) : null
      )}
    </>
  )
}
